module.exports = __webpack_public_path__ + "static/media/akar-icons_info-fill.54c9fdf3.svg";